<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备类型编码" prop="code" >
        <a-input v-model="form.code" placeholder="请输入设备类型编码" />
      </a-form-model-item>
      <a-form-model-item label="设备类型名称，如太空舱pro" prop="name" >
        <a-input v-model="form.name" placeholder="请输入设备类型名称，如太空舱pro" />
      </a-form-model-item>
      <a-form-model-item label="图标" prop="icon" >
        <a-input v-model="form.icon" placeholder="请输入图标" />
      </a-form-model-item>
      <a-form-model-item label="蓝牙广播前缀/匹配规则" prop="bluetoothPrefix" >
        <a-input v-model="form.bluetoothPrefix" placeholder="请输入蓝牙广播前缀/匹配规则" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getType, addType, updateType } from '@/api/mibo/type'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        code: null,

        name: null,

        icon: null,

        bluetoothPrefix: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        code: [
          { required: true, message: '设备类型编码不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '设备类型名称，如太空舱pro不能为空', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '图标不能为空', trigger: 'blur' }
        ],
        bluetoothPrefix: [
          { required: true, message: '蓝牙广播前缀/匹配规则不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        code: null,
        name: null,
        icon: null,
        bluetoothPrefix: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getType({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateType(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addType(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
